import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import FormSubmissions from "./formSubmissions";

const feature = "formSubmissions";

const InitialState = Record({
  formSubmissions: new FormSubmissions()
});

const START = "_START";
const SUCCESS = "_SUCCESS";
const ERROR = "_ERROR";

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function FormsSubmissionsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.formSubmissions
    ) {
      state = state.updateIn(
        ["formSubmissions", "entities"],
        map => map.mergeDeep(action.payload.entities.formSubmissions)
      );
    }
  }

  switch (action.type) {
    case actions.GET_FORM_SUBMISSIONS + START: {
      return state.setIn(["formSubmissions", "loading"], true);
    }
    case actions.GET_FORM_SUBMISSIONS + SUCCESS: {
      state = state.deleteIn(["formSubmissions", "entities"]);
      state = state.deleteIn(["formSubmissions", "results"]);
      state = state.setIn(
        ["formSubmissions", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["formSubmissions", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(
        ["formSubmissions", "entities"],
        map => map.mergeDeep(action.payload.entities.formSubmissions)
      );
      state = state.setIn(
        ["formSubmissions", "results"],
        action.payload.result.formSubmissions
      );
      return state.setIn(["formSubmissions", "loading"], false);
    }
    case actions.GET_FORM_SUBMISSIONS + ERROR: {
      return state.setIn(["formSubmissions", "loading"], false);
    }

    case actions.GET_FORM_SUBMISSION + START: {
      return state.setIn(["formSubmissions", "loading"], true);
    }
    case actions.GET_FORM_SUBMISSION + SUCCESS: {
      return state.setIn(["formSubmissions", "loading"], false);
    }
    case actions.GET_FORM_SUBMISSION + ERROR: {
      return state.setIn(["formSubmissions", "loading"], false);
    }

    case actions.PATCH_FORM_SUBMISSIONS + START: {
      return state.setIn(["formSubmissions", "loading"], true);
    }
    case actions.PATCH_FORM_SUBMISSIONS + SUCCESS: {
      return state.setIn(["formSubmissions", "loading"], false);
    }
    case actions.PATCH_FORM_SUBMISSIONS + ERROR: {
      return state.setIn(["formSubmissions", "loading"], false);
    }

    case actions.DELETE_FORM_SUBMISSION + START: {
      return state.deleteIn([
        "formSubmissions",
        "entities",
        action.payload.uid
      ]);
    }

    case actions.SET_IS_REMOVE_FORM_SUBMISSION_MODAL_VISIBLE: {
      return state.setIn(
        ["formSubmissions", "isRemoveModalVisible"],
        action.data.isVisble
      );
    }
    case actions.SET_IS_EDIT_FORM_SUBMISSION_MODAL_VISIBLE: {
      return state.setIn(
        ["formSubmissions", "isEditModalVisible"],
        action.data.isVisble
      );
    }
  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/formSubmissions/reducer.js